import { z } from "zod";
import { PARTICIPANT_PHOTO_URL_SCHEME } from "./storage-file.schemas.js";

// Brand accepts every shape the URL takes through its lifecycle:
// `evt-participant-photo://` placeholder, external `https?://`, or post-resolve `/api/v1/...` path.
export function isValidParticipantPhotoUrl(value: string): boolean {
  if (typeof value !== "string") return false;
  return (
    value.startsWith(PARTICIPANT_PHOTO_URL_SCHEME) ||
    value.startsWith("https://") ||
    value.startsWith("http://") ||
    value.startsWith("/api/")
  );
}

export const ParticipantPhotoUrlSchema = z
  .string()
  .refine(isValidParticipantPhotoUrl, {
    message: "Invalid participant photo URL",
  })
  .brand("ParticipantPhotoUrl");

export type ParticipantPhotoUrl = z.infer<typeof ParticipantPhotoUrlSchema>;

/**
 * A stored photo value as a renderable URL, or no photo. The single degrade rule:
 * these reads sit inside a list's decode step, so throwing on one unusable value
 * would cost every row of the list its render.
 */
export function toParticipantPhotoUrlOrNull(
  raw: string | null,
): ParticipantPhotoUrl | null {
  if (raw === null) return null;
  const parsed = ParticipantPhotoUrlSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
